(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 749;

  function initSection(section) {
    if (!section || section.getAttribute('data-editorial-slider-ready') === 'true') return;

    var track = section.querySelector('[data-editorial-slider]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-editorial-slide]')) : [];
    var controls = section.querySelector('[data-editorial-slider-controls]');
    var previous = controls ? controls.querySelector('[data-editorial-prev]') : null;
    var next = controls ? controls.querySelector('[data-editorial-next]') : null;
    var current = controls ? controls.querySelector('[data-editorial-current]') : null;
    var frame = null;

    if (!track || slides.length < 2) return;

    section.setAttribute('data-editorial-slider-ready', 'true');

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function activeIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function update() {
      frame = null;
      var index = activeIndex();
      if (current) current.textContent = String(index + 1);
      if (previous) previous.disabled = !isMobile() || index === 0;
      if (next) next.disabled = !isMobile() || index === slides.length - 1;
    }

    function requestUpdate() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(update);
    }

    function moveTo(index) {
      var target = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft - 14, behavior: 'smooth' });
    }

    if (previous) {
      previous.addEventListener('click', function () {
        moveTo(activeIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        moveTo(activeIndex() + 1);
      });
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(track);
    }

    update();
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-editorial-section].is-mobile-slider') : [];
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
